/**
 * Product gallery.
 *
 * Thumbnails, prev/next arrows, keyboard arrows and swipe all drive the same
 * index. The main image opens a lightbox that can be paged through too.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-nova-gallery]').forEach(setup);
  });

  function setup(gallery) {
    var main = gallery.querySelector('[data-nova-gallery-main]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-nova-gallery-thumb]'));
    if (!main || !thumbs.length) return;

    var prev = gallery.querySelector('[data-nova-gallery-prev]');
    var next = gallery.querySelector('[data-nova-gallery-next]');
    var zoom = gallery.querySelector('[data-nova-gallery-zoom]');
    var counter = gallery.querySelector('[data-nova-gallery-counter]');

    var sources = thumbs.map(function (t) { return t.dataset.full; });
    var index = 0;

    // A single image needs no navigation.
    if (thumbs.length < 2) {
      [prev, next, counter].forEach(function (el) { if (el) el.hidden = true; });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { show(i); });
    });

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    });

    // Swipe on touch devices.
    var startX = null;
    main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 45) step(dx < 0 ? 1 : -1);
      startX = null;
    }, { passive: true });

    if (zoom) zoom.addEventListener('click', function (e) { e.stopPropagation(); openLightbox(); });
    main.addEventListener('click', openLightbox);

    show(0);

    function step(delta) {
      show((index + delta + sources.length) % sources.length);
    }

    function show(i) {
      var full = sources[i];
      if (!full) return;

      index = i;

      var next = new Image();
      next.onload = function () {
        main.src = full;
        main.classList.remove('is-swapping');
      };
      main.classList.add('is-swapping');
      next.src = full;

      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === i);
        t.setAttribute('aria-current', n === i ? 'true' : 'false');
      });

      if (counter) counter.textContent = (i + 1) + ' / ' + sources.length;
    }

    function openLightbox() {
      lightbox(sources, index, function (i) { show(i); });
    }
  }

  function lightbox(sources, startIndex, onChange) {
    var i = startIndex;

    var box = document.createElement('div');
    box.className = 'nova-lightbox';
    box.innerHTML =
      '<button type="button" class="nova-lightbox__close" aria-label="Close">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none">' +
          '<path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
        '</svg></button>' +
      (sources.length > 1 ?
        '<button type="button" class="nova-lightbox__arrow nova-lightbox__arrow--prev" aria-label="Previous">' +
          '<svg width="22" height="22" viewBox="0 0 24 24" fill="none">' +
            '<path d="M15 5 8 12l7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg></button>' +
        '<button type="button" class="nova-lightbox__arrow nova-lightbox__arrow--next" aria-label="Next">' +
          '<svg width="22" height="22" viewBox="0 0 24 24" fill="none">' +
            '<path d="m9 5 7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg></button>' : '') +
      '<img src="' + sources[i] + '" alt="">' +
      (sources.length > 1 ? '<span class="nova-lightbox__counter"></span>' : '');

    document.body.appendChild(box);
    document.documentElement.classList.add('nova-drawer-open');
    requestAnimationFrame(function () { box.classList.add('is-open'); });

    var img = box.querySelector('img');
    var counter = box.querySelector('.nova-lightbox__counter');
    box.querySelector('.nova-lightbox__close').focus();
    paint();

    box.addEventListener('click', function (e) {
      if (e.target.closest('.nova-lightbox__close')) return close();
      if (e.target.closest('.nova-lightbox__arrow--prev')) return move(-1);
      if (e.target.closest('.nova-lightbox__arrow--next')) return move(1);
      if (e.target === box) close();
    });

    document.addEventListener('keydown', onKey);

    function onKey(e) {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') move(-1);
      if (e.key === 'ArrowRight') move(1);
    }

    function move(delta) {
      i = (i + delta + sources.length) % sources.length;
      paint();
      if (onChange) onChange(i);
    }

    function paint() {
      img.src = sources[i];
      if (counter) counter.textContent = (i + 1) + ' / ' + sources.length;
    }

    function close() {
      box.classList.remove('is-open');
      document.documentElement.classList.remove('nova-drawer-open');
      window.setTimeout(function () { box.remove(); }, 200);
      document.removeEventListener('keydown', onKey);
    }
  }
})();
